"use client";

import React from "react";

interface ChartCardProps {
	title: string
	children: React.ReactNode
}

export default function ChartCard({ title, children }: ChartCardProps) {
	return (
		<div className="bg-white shadow-xl rounded-2xl border border-gray-200 pt-4 sm:pt-5 pb-2 sm:pb-3 px-3 sm:px-4 overflow-hidden flex flex-col">
			<h2 className="text-lg sm:text-xl font-bold mb-3 sm:mb-4 text-center text-gray-800">
				{title}
			</h2>
			<div className="w-full h-[280px] sm:h-[320px] md:h-[360px] overflow-hidden">
				{children}
			</div>
		</div>
	)
}
